import type { Step } from "react-joyride";

export const kpiFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຟອມສ້າງ KPI! ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຟອມນີ້ໃນບົດສອນສັ້ນໆນີ້. KPI ຈະຊ່ວຍທ່ານວັດແລະປະເມີນຜົນການເຮັດວຽກຂອງພະນັກງານ, ພະແນກກ, ຫຼືອົງກອນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="form-name"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຊື່ KPI. ກະລຸນາໃສ່ຊື່ທີ່ຊັດເຈນແລະອະທິບາຍວ່າ KPI ນີ້ວັດແນວໃດ. ຕົວຢ່າງ: 'ອັດຕາການມາຮອດຂອງພະນັກງານ' ຫຼື 'ຍອດຂາຍລາຍເດືອນ'. ຊ່ອງນີ້ຈຳເປັນຕ້ອງປ້ອນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-level"]',
    content:
      "ນີ້ແມ່ນການເລືອກລະດັບ KPI. ທ່ານຕ້ອງເລືອກລະດັບທີ່ເໝາະສົມກັບ KPI ຂອງທ່ານ: ພະນັກງານ (ວັດຜົນການເຮັດວຽກຂອງພະນັກງານແຕ່ລະຄົນ), ພະແນກກ (ວັດຜົນການເຮັດວຽກຂອງພະແນກກ), ຫຼືອົງກອນ (ວັດຜົນການເຮັດວຽກຂອງທັງອົງກອນ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-description"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຄຳອະທິບາຍ. ທ່ານສາມາດໃສ່ຄຳອະທິບາຍເພີ່ມເຕີມກ່ຽວກັບ KPI ນີ້ (ບໍ່ບັງຄັບ). ຄຳອະທິບາຍຈະຊ່ວຍໃຫ້ຜູ້ໃຊ້ອື່ນເຂົ້າໃຈຈຸດປະສົງຂອງ KPI ນີ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-measurement-source"]',
    content:
      "ນີ້ແມ່ນຊ່ອງແຫຼ່ງຂໍ້ມູນ. ທ່ານສາມາດໃສ່ວ່າຂໍ້ມູນມາຈາກໃສ (ບໍ່ບັງຄັບ). ຕົວຢ່າງ: 'ຈາກ Checklist Execution', 'ຈາກລະບົບຂາຍ', ຫຼື 'ຈາກການນັບດ້ວຍຕົນເອງ'. ຖ້າບໍ່ຊັດເຈນສາມາດຂ້າມໄດ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-measurement-period"]',
    content:
      "ນີ້ແມ່ນການເລືອກຮອບການວັດ. ເລືອກວ່າ KPI ນີ້ຄວນຖືກວັດເມື່ອໃດ: ເດືອນ (ປະຈຳເດືອນ), ໄຕມາດ (ປະຈຳໄຕມາດ), ຫຼືປີ (ປະຈຳປີ). ຊ່ອງນີ້ຈຳເປັນຕ້ອງເລືອກ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-measurement-method"]',
    content:
      "ນີ້ແມ່ນຊ່ອງວິທີການວັດ (ນັບຢ່າງໃດ). ທ່ານຕ້ອງກະລຸນາອະທິບາຍວິທີການນັບຫຼືຄິດໄລ່ແບບງ່າຍໆ, ຫຼີກລ້ຽງສູດສັບຊ້ອນ. ຕົວຢ່າງ: 'ນັບຈາກຍອດຂາຍທັງໝົດຂອງພະແນກໃນແຕ່ລະເດືອນ'. ຊ່ອງນີ້ຈຳເປັນຕ້ອງປ້ອນ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-target-value"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຄ່າເປົ້າໝາຍ. ທ່ານສາມາດໃສ່ຄ່າເປົ້າໝາຍເປັນຕົວເລກ (ບໍ່ບັງຄັບ). ຕົວຢ່າງ: 80 (ຖ້າເປົ້າໝາຍແມ່ນ 80%), 1000000 (ຖ້າເປົ້າໝາຍແມ່ນ 1,000,000 ບາດ). ສາມາດກຳນົດໃຫ້ທັນເວລາໄດ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-target-unit"]',
    content:
      "ນີ້ແມ່ນການເລືອກຫົວໜ່ວຍຂອງຄ່າເປົ້າໝາຍ. ເລືອກຫົວໜ່ວຍທີ່ສອດຄ່ອງກັບຄ່າເປົ້າໝາຍ ແລະ ກຳນົດການປະເມີນ: ເປີເຊັນ (%), ຈຳນວນຄັ້ງ, ຄະແນນ (1-10), ຫຼື ເງິນ ($). ຫົວໜ່ວຍນີ້ຈະຖືກນຳໃຊ້ໃນການປະເມີນກຳນົດຜ່ານແລະບໍ່ຜ່ານ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-pass-criteria"]',
    content:
      "ນີ້ແມ່ນຊ່ອງກຳນົດຜ່ານ. ທ່ານສາມາດກຳນົດເງື່ອນໄຂການຜ່ານໂດຍໃຊ້ຮູບແບບມາດຕະຖານ: ເລືອກໂອເປຣເຕີ (≥, >, ≤, <, =), ໃສ່ຄ່າ, ແລະຫົວໜ່ວຍຈະຖືກກຳນົດອັດຕະໂນມັດຕາມຫົວໜ່ວຍທີ່ເລືອກໃນຊ່ອງກ່ອນໜ້າ. ຕົວຢ່າງ: >= 80%, <= 5 ຄັ້ງ, = 100%. ກຳນົດນີ້ຈະຖືກໃຊ້ໃນການປະເມີນວ່າ KPI ຜ່ານຫຼືບໍ່.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-fail-criteria"]',
    content:
      "ນີ້ແມ່ນຊ່ອງກຳນົດບໍ່ຜ່ານ. ທ່ານສາມາດກຳນົດເງື່ອນໄຂການບໍ່ຜ່ານໂດຍໃຊ້ຮູບແບບມາດຕະຖານ: ເລືອກໂອເປຣເຕີ (≥, >, ≤, <, =), ໃສ່ຄ່າ, ແລະຫົວໜ່ວຍຈະຖືກກຳນົດອັດຕະໂນມັດຕາມຫົວໜ່ວຍທີ່ເລືອກໃນຊ່ອງກ່ອນໜ້າ. ຕົວຢ່າງ: < 60%, > 10 ຄັ້ງ. ກຳນົດນີ້ຈະຖືກໃຊ້ໃນການປະເມີນວ່າ KPI ບໍ່ຜ່ານ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-notes"]',
    content:
      "ນີ້ແມ່ນຊ່ອງໝາຍເຫດ. ທ່ານສາມາດໃສ່ຂໍ້ຄວາມເຕືອນ, ສິ່ງທີ່ບໍ່ເອົາມານັບ, ຫຼືຂໍ້ມູນເພີ່ມເຕີມ (ບໍ່ບັງຄັບ). ຕົວຢ່າງ: 'ບໍ່ນັບລາຍການທີ່ຍົກເລີກແລ້ວ', 'ຕ້ອງກວດສອບກ່ອນນັບ'.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-save-draft"]',
    content:
      "ນີ້ແມ່ນປຸ່ມບັນທຶກເປັນຮ່າງ (ສຳລັບການສ້າງໃໝ່ເທົ່ານັ້ນ). ຖ້າທ່ານຍັງບໍ່ພ້ອມທີ່ຈະໃຊ້ງານ KPI ນີ້, ທ່ານສາມາດກົດປຸ່ມນີ້ເພື່ອບັນທຶກ KPI ເປັນຮ່າງໄວ້ກ່ອນ. KPI ທີ່ບັນທຶກເປັນຮ່າງຈະບໍ່ຖືກນຳໃຊ້ແຕ່ທ່ານສາມາດມາແກ້ໄຂແລ້ວບັນທຶກອີກຄັ້ງໄດ້ເມື່ອພ້ອມ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-submit"]',
    content:
      "ຫຼັງຈາກຕື່ມຂໍ້ມູນຄົບຖ້ວນແລ້ວ, ກົດປຸ່ມ 'ບັນທຶກແລະເປີດໃຊ້' (ສຳລັບການສ້າງໃໝ່) ຫຼື 'ບັນທຶກ' (ສຳລັບການແກ້ໄຂ) ເພື່ອບັນທຶກ KPI ຂອງທ່ານ. KPI ທີ່ບັນທຶກແລ້ວຈະສາມາດໃຊ້ງານໄດ້ທັນທີ.",
    placement: "top",
  },
];
